import { render, staticRenderFns } from "./SendMailModal.vue?vue&type=template&id=5a4292d5&"
import script from "./SendMailModal.vue?vue&type=script&lang=js&"
export * from "./SendMailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports